<template>
  <div class="printBox page4 common">
    <div class="bg-t"></div>
    <div class="content">
      <div style="color: #0066CC;">
        <div style="font-size: 32px;">五、各指标情况统计分析</div>
        <div style="font-size: 16px;color: #333;text-indent: 2em;margin: 10px 0 20px;">各指标将从身心健康各指标与SCL-90心理状态各因子异常指标分别统计分析</div>
        <div style="font-size: 24px;">1、身心健康各指标统计分析</div>
      </div>
      <div class="chart-content">
        <div class="chartBox">
          <div class="title">A、睡眠状态指标</div>
          <div class="chart1" ref="chartRef1" style="width: 100%;height: 100%;">
            
          </div>
        </div>
        <div class="chartBox">
          <div class="title">B、承压指数和焦虑指数</div>
          <div class="chart2" ref="chartRef2" style="width: 100%;height: 100%;">
            
          </div>
        </div>
      </div>
    </div>
    <div class="bg-b"></div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch } from "vue";
import * as echarts from "echarts";

const props = defineProps(["data"]);

const chartRef1 = ref(null);
const chartRef2 = ref(null);
let chartInstance1 = null;
let chartInstance2 = null;

const init = () => {
  chartInstance1 = echarts.init(chartRef1.value);
  chartInstance2 = echarts.init(chartRef2.value);
};

onMounted(() => {
  nextTick(() => {
    init();
  })
});

watch(
  () => props.data,
  (val) => {
    setChart1(val.healthResultList);
    setChart2(val.tableResultList.filter((item) => {
      return item.name === '承压指数' || item.name === '焦虑指数'
    }));
  },
  { deep: true }
);

const setChart1 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '睡眠状态指标示意图',
      left: 'center'
    },
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      right: '0',
      top: 'middle',
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: '50%',
        label: {
          fontSize: 12,
          formatter: ({ name, percent, value }) => {
            return `${name}\n人数：${value}\n占比 ${percent.toFixed(2)}%`;
          }
        },
        data: val.map((item) => {
          return {
            name: item.result,
            value: item.peopleData.numberPeople,
          }
        }),
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };
  chartInstance1 && chartInstance1.setOption(option);
}
const setChart2 = (val) => {
  const option = {
    title: {
      text: '',
      subtext: '承压指数和焦虑指数示意图',
      left: 'center'
    },
    tooltip: {
      trigger: 'item',
    },
    // legend: {
    //   orient: 'vertical',
    //   right: '0',
    //   bottom: '0',
    // },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: [0, '30%'],
        label: {
          position: 'outside',
          fontSize: 10,
          formatter: '{b}\n人数：{c}\n占比 {d}%',
        },
        labelLine: {
          show: true
        },
        data: [
          { 
            value: val.find((item) => item.name === '承压指数').normalData.numberPeople,
            name: '正常承压' 
          },
          { 
            value: val.find((item) => item.name === '承压指数').tallData.numberPeople,
            name: '承压较高' 
          },
          { 
            value: val.find((item) => item.name === '焦虑指数').normalData.numberPeople,
            name: '正常焦虑' 
          },
          { 
            value: val.find((item) => item.name === '焦虑指数').tallData.numberPeople,
            name: '焦虑较高' 
          },
        ]
      },
      {
        name: 'Access From',
        type: 'pie',
        radius: ['45%', '60%'],
        labelLine: {
          length: 30
        },
        label: {
          formatter: '{b}\n人数：{c}\n占比 {d}%',
          fontSize: 12,
        },
        data: [
          { 
            value: val.reduce((a, b) => a + b.normalData.numberPeople, 0), 
            name: '正常区间' 
          },
          { 
            value: val.reduce((a, b) => a + b.tallData.numberPeople, 0),
            name: '较高区间' 
          },
        ]
      }
    ]
  };
  chartInstance2 && chartInstance2.setOption(option);
}
</script>

<style lang="scss" scoped>
.page4{
  position: relative;
}
.page4 .title{
  font-size: 32px;
  color: #000;
}
.page4 .content{
  padding: 40px;
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
}
.page4 .chart-content{
  padding: 20px;
  display: grid;
  grid-template-rows: repeat(2,1fr);
}
.page4 .chartBox{
  display: grid;
  grid-template-rows: auto 1fr;
}
.page4 .bg-t{
  position: absolute;
  top: 0;
  right: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-rt.png") no-repeat;
  background-size: 100% 100%;
}
.page4 .bg-b{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-lb.png") no-repeat;
  background-size: 100% 100%;
}
</style>